'use strict';

import { showModal } from '../components/modal';
import { tryParseJSON } from 'app_vodafone_ziggo/util/util';

/**
 * @public insertResponse
 * @param {string} response - The response from the server. We should make this consistent in the future
 */
function insertResponse(response) {
    const parsedResponse = tryParseJSON(response);

    if ('html' in parsedResponse) {
        this.mainContainer.insertAdjacentHTML('beforeend', parsedResponse.html);
    } else if (typeof response === 'string' && response.indexOf('bscan-step') >= 0) {
        this.mainContainer.insertAdjacentHTML('beforeend', response);
    } else {
        console.error('fn insertResponse: Unrecognized response type!', response);
    }
}

/**
 * @public handleError
 * @param {Object} eventObject - The event object, containing the response from the server
 */
function handleError(eventObject) {
    let errorModal = document.querySelector(this.selectors.errorModal);

    if (!errorModal) {
        insertResponse(eventObject.detail);
        errorModal = document.querySelector(this.selectors.errorModal);
    }

    if (errorModal) {
        errorModal.classList.add(this.CONST.classes.active);
    } else {
        try {
            showModal('try-again-modal', 'Can\'t find "try again" modal');
        } catch {
            console.error('fn handleError: No modal available to show');
        }
    }
}

export { insertResponse, handleError };
